<div
    class="cmps-cdk-w-100pct cmps-cdk-h-100pct cmps-cdk-overflow-y-auto cmps-gp-bg-color-ukn-103"
>
    <div class="cmps-cdk-p-1 cmps-cdk-max-w-1664px cmps-cdk-m-auto">
        <div *ngIf="_state.loading !== true">
            <div
                class="cmps-cdk-d-flex cmps-cdk-align-items-center gp-toolbar"
                *ngIf="_state.rows?.length > 0"
            >
                <img
                    src="assets/intelligent-coach-assist-icon.svg"
                    class="gp-page-title-icon"
                    alt=""
                    aria-hidden="true"
                />
                <div class="gp-page-title">
                    <h1 class="gp-page-title__name">
                        {{ _i18n._11300_GAME_PLAN | translate }}
                    </h1>
                    <span class="gp-page-title__meta"
                        >{{ _state.rows?.length ?? 0 }}
                        {{ _i18n._11301_PEOPLE | translate }} ·
                        {{ _state.totalActionCount }}
                        {{ _i18n._11302_ACTIONS_META | translate }}</span
                    >
                </div>
                <div class="gp-toolbar-controls">
                    <cmps-button-group
                        #viewRef
                        [ngModel]="view"
                        (ngModelChange)="view = $event"
                    >
                        <button
                            type="button"
                            class="cmps-cdk-border-tl-radius-4p cmps-cdk-border-bl-radius-4p"
                            [class.cmps-cdk-bg-color-blue-100]="
                                viewRef.value === 'person'
                            "
                            [class.cmps-cdk-border-color-blue-100]="
                                viewRef.value === 'person'
                            "
                            [class.cmps-cdk-color-white]="
                                viewRef.value === 'person'
                            "
                            [attr.aria-pressed]="viewRef.value === 'person'"
                            cmpsButtonGroupItem
                            [value]="'person'"
                        >
                            <span class="gp-toolbar-btn-content">
                                <cmps-icon
                                    svgIcon="account"
                                    class="gp-toolbar-icon"
                                    [class.cmps-cdk-fill-white]="
                                        viewRef.value === 'person'
                                    "
                                ></cmps-icon>
                                {{ _i18n._11278_BY_PERSON | translate }}
                            </span>
                        </button>
                        <button
                            class="cmps-cdk-border-tr-radius-4p cmps-cdk-border-br-radius-4p"
                            type="button"
                            [class.cmps-cdk-bg-color-blue-100]="
                                viewRef.value === 'action'
                            "
                            [class.cmps-cdk-border-color-blue-100]="
                                viewRef.value === 'action'
                            "
                            [class.cmps-cdk-color-white]="
                                viewRef.value === 'action'
                            "
                            [attr.aria-pressed]="viewRef.value === 'action'"
                            cmpsButtonGroupItem
                            [value]="'action'"
                        >
                            <span class="gp-toolbar-btn-content">
                                <cmps-icon
                                    svgIcon="view-dashboard-outline"
                                    class="gp-toolbar-icon"
                                    [class.cmps-cdk-fill-white]="
                                        viewRef.value === 'action'
                                    "
                                ></cmps-icon>
                                {{ _i18n._11279_BY_ACTION | translate }}
                            </span>
                        </button>
                    </cmps-button-group>
                    <cmps-button-group
                        *ngIf="view === 'person'"
                        #subviewRef
                        [ngModel]="personSubview"
                        (ngModelChange)="personSubview = $event"
                        class="gp-subview-toggle"
                    >
                        <button
                            type="button"
                            class="cmps-cdk-border-tl-radius-4p cmps-cdk-border-bl-radius-4p"
                            [class.cmps-cdk-bg-color-blue-100]="
                                subviewRef.value === 'tile'
                            "
                            [class.cmps-cdk-border-color-blue-100]="
                                subviewRef.value === 'tile'
                            "
                            [class.cmps-cdk-color-white]="
                                subviewRef.value === 'tile'
                            "
                            [attr.aria-pressed]="subviewRef.value === 'tile'"
                            cmpsButtonGroupItem
                            [value]="'tile'"
                            [cmpsTooltipTrigger]="
                                _i18n._11280_TILE_VIEW | translate
                            "
                        >
                            <cmps-icon
                                svgIcon="view-grid"
                                class="gp-toolbar-icon"
                                [class.cmps-cdk-fill-white]="
                                    subviewRef.value === 'tile'
                                "
                            ></cmps-icon>
                        </button>
                        <button
                            type="button"
                            class="cmps-cdk-border-tr-radius-4p cmps-cdk-border-br-radius-4p"
                            [class.cmps-cdk-bg-color-blue-100]="
                                subviewRef.value === 'grid'
                            "
                            [class.cmps-cdk-border-color-blue-100]="
                                subviewRef.value === 'grid'
                            "
                            [class.cmps-cdk-color-white]="
                                subviewRef.value === 'grid'
                            "
                            [attr.aria-pressed]="subviewRef.value === 'grid'"
                            cmpsButtonGroupItem
                            [value]="'grid'"
                            [cmpsTooltipTrigger]="
                                _i18n._11281_GRID_VIEW | translate
                            "
                        >
                            <cmps-icon
                                svgIcon="view-list"
                                class="gp-toolbar-icon"
                                [class.cmps-cdk-fill-white]="
                                    subviewRef.value === 'grid'
                                "
                            ></cmps-icon>
                        </button>
                    </cmps-button-group>
                    <div
                        class="gp-search cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4p"
                        [class.gp-search--open]="_state.searchOpen"
                    >
                        <input
                            class="gp-search__input"
                            cmpsSearchInput
                            type="text"
                            [attr.aria-label]="
                                _i18n._11304_SEARCH_PERFORMERS | translate
                            "
                            [attr.placeholder]="_i18n._11282_SEARCH | translate"
                            [keyword]="_state.keyword"
                            (blur)="_onSearchBlur()"
                            *ngIf="_state.searchOpen === true"
                        />
                        <button
                            type="button"
                            cmpsIconButton
                            class="cmps-icon-button--no-bg"
                            [attr.aria-label]="
                                _i18n._11304_SEARCH_PERFORMERS | translate
                            "
                            (mousedown)="$event.preventDefault()"
                            (click)="_onSearchOpen()"
                            [cmpsTooltipTrigger]="
                                _i18n._11282_SEARCH | translate
                            "
                        >
                            <cmps-icon
                                svgIcon="magnify"
                                aria-hidden="true"
                                [class.cmps-cdk-fill-blue-100]="
                                    _state.searchOpen === true ||
                                    _state.keyword?.length > 0
                                "
                            ></cmps-icon>
                        </button>
                        <button
                            type="button"
                            class="cmps-icon-button--no-bg cmps-cdk-border-l-width-1px cmps-cdk-border-l-solid cmps-cdk-border-l-color-grey-300"
                            cmpsIconButton
                            [attr.aria-label]="_i18n.__FILTER | translate"
                            [cmpsOverlayTrigger]="filterTpl"
                            [cmpsTooltipTrigger]="_i18n.__FILTER | translate"
                        >
                            <cmps-icon
                                [class.cmps-cdk-fill-blue-100]="
                                    _state.selectedPersonaFilterOptions?.size >
                                    0
                                "
                                svgIcon="filter-outline"
                                aria-hidden="true"
                            ></cmps-icon>
                        </button>
                        <button
                            type="button"
                            cmpsIconButton
                            class="cmps-icon-button--no-bg cmps-cdk-border-l-width-1px cmps-cdk-border-l-solid cmps-cdk-border-l-color-grey-300"
                            [attr.aria-label]="_i18n._11326_LEGEND | translate"
                            (click)="_onLegendClick()"
                            [cmpsTooltipTrigger]="
                                _i18n._11326_LEGEND | translate
                            "
                        >
                            <cmps-icon
                                svgIcon="information-outline"
                                aria-hidden="true"
                            ></cmps-icon>
                        </button>
                    </div>
                </div>
            </div>

            <span
                class="sr-only"
                aria-live="polite"
                >{{ _state.filteredRows?.length }}
                {{ _i18n._11303_RESULTS | translate }}</span
            >

            <!-- By Person — Tile view -->
            <div
                *ngIf="view === 'person' && personSubview === 'tile'"
                class="gp-tile-grid"
            >
                <ng-container
                    *ngFor="
                        let group of _state.personaGroups;
                        trackBy: _trackByPersona
                    "
                >
                    <cmps-gp-persona-tile
                        [group]="group"
                        *ngIf="group.rows?.length > 0"
                        (wpClick)="_onWpClick($event)"
                    ></cmps-gp-persona-tile>
                </ng-container>
            </div>

            <!-- By Person — Grid view (flat table) -->
            <cmps-gp-grid
                *ngIf="view === 'person' && personSubview === 'grid'"
                [rows]="_state.filteredRows"
                (wpClick)="_onWpClick($event)"
            ></cmps-gp-grid>

            <!-- By Action view — Kanban lanes -->
            <div
                *ngIf="view === 'action'"
                class="gp-activity-grid"
            >
                <ng-container
                    *ngFor="
                        let lane of _state.actionLanes;
                        trackBy: _trackByLane
                    "
                >
                    <cmps-gp-lane
                        [lane]="lane"
                        *ngIf="lane.rows?.length > 0"
                    ></cmps-gp-lane>
                </ng-container>
            </div>
        </div>
        <div
            class="cmps-cdk-d-flex cmps-cdk-flex-direction-column cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-min-h-128p"
            *ngIf="_state.loading === true"
        >
            <cmps-icon
                svgIcon="loading"
                class="cmps-cdk-w-32px cmps-cdk-h-32px cmps-cdk-nested:cmps-cdk-w-inherit cmps-cdk-nested:cmps-cdk-h-inherit cmps-cdk-fill-grey-400"
            ></cmps-icon>
            <span
                class="cmps-cdk-color-grey-400 cmps-cdk-font-size-14p cmps-cdk-mt-0dot5"
                >Loading ...</span
            >
        </div>
    </div>
</div>

<ng-template #filterTpl>
    <cmps-gp-filter></cmps-gp-filter>
</ng-template>
